"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const strings_1 = require("../../../../../assets/strings/strings");
const AccommodationService_1 = __importDefault(require("../../../../../services/AccommodationService"));
const detectDevice_1 = __importDefault(require("../../../../../utils/detectDevice"));
const message_utils_1 = __importDefault(require("../../../../../utils/message_utils"));
const underline_1 = __importDefault(require("../../../../../components/underline"));
require("./ConfirmCheckout.scss");
const CheckoutMessageErrorDefault = {
    message: 'Ocorreu um erro',
    description: 'Ocorreu um erro na tentativa de realizar check-out, tente novamente',
};
const linkSurveyHubspot = 'https://survey.hsforms.com/1eFX_0lImTMOsU9yd9QnKogc0ygv';
const styles = { marginLeft: '32px', marginBottom: '30px' };
const MOBILE_WIDTH = 992;
const ConfirmCheckout = ({ bookId, propertyId, close, reloadBookings }) => {
    const [loading, setLoading] = (0, react_1.useState)(false);
    const { isMobile } = (0, detectDevice_1.default)(MOBILE_WIDTH);
    const goToSurveyCheckout = () => {
        isMobile
            ? setTimeout(() => {
                window.location.href = `${linkSurveyHubspot}`;
            }, 4000)
            : window.open(linkSurveyHubspot, '_blank');
    };
    const handleConfirm = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const message = isMobile
            ? strings_1.AccommodationMessages.accommodationCheckoutSuccessMobile
            : strings_1.AccommodationMessages.accommodationCheckoutSuccessDesktop;
        try {
            setLoading(true);
            const response = yield AccommodationService_1.default.checkoutAccommodation({ propertyId, bookId });
            if (response.booking.success) {
                message_utils_1.default.success({ message });
                goToSurveyCheckout();
                reloadBookings();
            }
        }
        catch (err) {
            const error = err.response && err.response.data ? err.response.data : CheckoutMessageErrorDefault;
            message_utils_1.default.error(error);
        }
        finally {
            setLoading(false);
            close();
        }
    }), [propertyId, bookId, close, reloadBookings]);
    return (react_1.default.createElement("div", { className: "ConfirmCheckout" },
        react_1.default.createElement("span", { className: "title" },
            "Check-out",
            react_1.default.createElement("span", null, ` hospedagem `)),
        react_1.default.createElement(underline_1.default, { style: styles }),
        react_1.default.createElement("span", { className: "sub-title" }, "Deseja realizar o seu check-out?"),
        react_1.default.createElement("div", { className: "actions" },
            react_1.default.createElement(antd_1.Button, { onClick: close, style: { borderRadius: '5px' } }, "N\u00E3o"),
            react_1.default.createElement(antd_1.Button, { onClick: handleConfirm, type: "primary", style: { borderRadius: '5px' }, loading: loading }, "Sim, realizar check-out."))));
};
exports.default = ConfirmCheckout;
